import EventEmitter from '@/utils/EventEmitter'
import api from './api'
import { concantQuery } from '@/utils/concatQuery'

export const CommentEventEmitter = new EventEmitter()

const wsEvents = {
  COMMENT_ADD: 'COMMENT_ADD',
  COMMENT_DELETE: 'COMMENT_DELETE',
  COMMENT_UPDATE: 'COMMENT_UPDATE',
  USER_MANAGER_EDIT_COMMENT: 'USER_MANAGER_EDIT_COMMENT',
  USER_MANAGER_UPDATE_COMMENT: 'USER_MANAGER_UPDATE_COMMENT'
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => CommentEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    CommentEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_COMMENTS: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_USER_MANAGER'))
  },
  ACTION_DELETE_COMMENTS: (params) => {
    wrapAction(() => wsActions.socket.emit('ACTION_DELETE_COMMENTS', params))
  },
  ACTION_EDIT_COMMENT: (comment) => {
    wrapAction(() => wsActions.socket.emit('ACTION_EDIT_COMMENT', comment))
  }
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  wsActions.socket = socket

  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => CommentEventEmitter.emit(eventName, args))
  })
}

/**
 * Get comments.
 */
const loadComments = ({ take, skip, search }) => {
  return api.get(`/statistical/comments${concantQuery({ take, skip, search })}`)
}

export {
  loadComments,
  bindWsEvents,
  wsEvents,
  wsListeners,
  wsActions
}
